import React from "react";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import "@splidejs/react-splide/css";
import SecTitle from "../Common/SecTitle";
const OverView = () => {
  return (
    <section className="bg-dark-blue py-5 text-white">
      <div className="my-5">
        <div className="row mx-0 align-items-center">
          <SecTitle title="خلاصه چشم انداز" />

          <div className="col-lg-5 mb-3">
            <Splide
              className="dir_ltr"
              aria-label="My Favorite Images"
              options={{
                rewind: true,
                gap: "1rem",
                perPage: 3,
                type: "loop",
                pagination: false,
                autoplay: true,
                interval: 10000,
                drag: true,
                easing: "ease",
              }}
            >
              <SplideSlide>
                <img
                  src="images/company2.jpg"
                  alt="Image 1"
                  className="img-fluid rounded-1"
                />
              </SplideSlide>
              <SplideSlide>
                <img
                  src="images/company1.jpg"
                  alt="Image 1"
                  className="img-fluid rounded-1"
                />
              </SplideSlide>
              <SplideSlide>
                <img
                  src="images/company2.jpg"
                  alt="Image 1"
                  className="img-fluid rounded-1"
                />
              </SplideSlide>
              <SplideSlide>
                <img
                  src="images/company1.jpg"
                  alt="Image 1"
                  className="img-fluid rounded-1"
                />
              </SplideSlide>
            </Splide>
          </div>
          <div className="col-lg-1"></div>
          <div className="col-lg-5">
            <p>
              چشم انداز شرکت ما، ایجاد ارزش برای مشتریان از طریق فناوری های
              نوین، افزایش مستمر تخصص خود در حوزه فناوری اطلاعات، توسعه روابط
              موثر با مشتریان و رشد برای بهبود مستمر عملکرد شرکت برای ایجاد
              رسیدن به جایگاه تخصصی محور بودن عملکرد شرکت است .
            </p>
          </div>
          <div className="col-lg-1"></div>
        </div>
      </div>
    </section>
  );
};

export default OverView;
